
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api"; // Your shared axios instance
import { hideLoader, showLoader } from "./loaderSlice";

export const getDepartmentList = createAsyncThunk(
  "getDepartmentList",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(`/getall/clinic/roles`);

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        // Filter only departments
        return res?.data?.data?.filter((item) => item.type === "department") || [];
      }
      thunkAPI.dispatch(hideLoader());
      return [];
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch departments");
    }
  }
);

export const createDepartment = createAsyncThunk(
  "createDepartment",
  async ({ roleName }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/create/clinic/role?type=department&roleName=${roleName}`
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to create department");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const updateDepartment = createAsyncThunk(
  "updateDepartment",
  async ({ roleId, roleName }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/update/clinic/role/${roleId}?type=department&roleName=${roleName}`
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to update department");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const deleteDepartment = createAsyncThunk(
  "deleteDepartment",
  async ({ roleId }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/delete/clinic/role/${roleId}`
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return roleId; // Return ID to remove from list
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to delete department");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  }
);

const departmentSlice = createSlice({
  name: "department",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDepartmentList.fulfilled, (state, action) => {
        state.list = action.payload ?? [];
        state.loading = false;
        state.error = null;
      })
      .addCase(createDepartment.fulfilled, (state, action) => {
        state.list.push(action.payload);
        state.loading = false;
        state.error = null;
      })
.addCase(updateDepartment.fulfilled, (state, action) => {
  const updated = action.payload;
  const index = state.list.findIndex((d) => d.roleId === updated.roleId);
  if (index !== -1) {
    state.list[index] = updated;
  }
})    .addCase(deleteDepartment.fulfilled, (state, action) => {
        
    const id = action.payload;
        state.list = state.list.filter((d) => d.roleId !== id);
        state.loading = false;
        state.error = null;
      })
      .addCase(getDepartmentList.pending, (state) => {
        state.loading = true;
      })
      .addCase(createDepartment.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateDepartment.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteDepartment.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDepartmentList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error fetching departments.";
      });
  },
});

export default departmentSlice.reducer;